import React, { useEffect, useState } from 'react';
import { Bell, BellOff } from 'lucide-react';
import { toast } from 'sonner';
import { isPushSupported, subscribeToPush, unsubscribeFromPush, getPushStatus } from '../utils/push';

const PushToggle = ({ compact = false }) => {
  const [status, setStatus] = useState('loading');
  const [busy, setBusy] = useState(false);

  const refresh = async () => setStatus(await getPushStatus());

  useEffect(() => { refresh(); }, []);

  if (!isPushSupported()) return null;
  if (status === 'unsupported') return null;

  const subscribed = status === 'subscribed';
  const denied = status === 'denied';

  const toggle = async () => {
    setBusy(true);
    try {
      if (subscribed) {
        await unsubscribeFromPush();
        toast.success('Push notifications disabled');
      } else if (denied) {
        toast.error('Notifications blocked in browser. Enable from browser settings.');
      } else {
        const r = await subscribeToPush();
        if (r.ok) toast.success('Push notifications enabled');
        else if (r.reason === 'denied') toast.error('Permission denied');
        else toast.error('Could not enable notifications');
      }
      await refresh();
    } catch (e) {
      toast.error('Failed to update notification settings');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      data-testid="push-toggle-btn"
      className={subscribed ? 'primary-button' : 'outline-button'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        fontSize: compact ? '0.8rem' : '0.9rem',
        padding: compact ? '0.4rem 0.8rem' : '0.6rem 1rem',
      }}
      title={denied ? 'Blocked in browser' : (subscribed ? 'Disable notifications' : 'Enable notifications')}
    >
      {subscribed ? <Bell size={16} /> : <BellOff size={16} />}
      {compact ? (subscribed ? 'On' : 'Off') : (subscribed ? 'Notifications On' : (denied ? 'Notifications Blocked' : 'Enable Notifications'))}
    </button>
  );
};

export default PushToggle;
